import { getPolicyQuestions } from '../../common/api.endPoints';
import { HttpService } from '../../common/http.service';

export async function fetchPolicyQuestions(policyId: number): Promise<unknown> {
  const data = await HttpService.getInstance().get(
    getPolicyQuestions(policyId),
  );
  if (data && !data.error) return data.parsedBody;
  return [];
}
